import { useEffect, useState } from "react";
import { PageHeader } from "../components/PageHeader";
import { CTABand } from "../components/CTABand";
import { Reveal } from "../components/Reveal";
import { FAQAccordion } from "../components/FAQAccordion";
import { getFaqs } from "../lib/api";

export default function FaqsPage() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { getFaqs().then(setFaqs).catch(() => {}); }, []);

  const categories = [...new Set(faqs.map((f) => f.category))];

  return (
    <div data-testid="faqs-page">
      <PageHeader
        eyebrow="Questions & answers"
        title="Frequently asked questions"
        lead="Answers to common questions about what we do, the sectors we serve, and how to work with us."
        crumb="FAQs"
      />
      <section className="section bg-paper">
        <div className="wrap">
          {categories.map((cat, ci) => (
            <Reveal key={cat} style={{ marginBottom: 40 }}>
              <span className="eyebrow" style={{ marginBottom: 18, display: "inline-flex" }}>{cat}</span>
              <FAQAccordion items={faqs.filter((f) => f.category === cat)} testid={`faq-${cat.toLowerCase().replace(/\s/g, "-")}`} />
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand />
    </div>
  );
}
